import React from 'react';
import PropTypes from 'prop-types';
import { CountryFlag } from 'project/country-flag';
import { getPlayerStatusSuffix } from './action-helper';

const QualLeaderboardDefaultView = (props) => {
    const { qualDrawCellClass } = props;
    return (
        <div className="qual-draw__table qual-draw__table--player">
            <div className="qual-draw__row">
                <div className={`${qualDrawCellClass} qual-draw__cell--player qual-draw__cell--title`}>
                    <div className="qual-draw__cell-title">
                        <div className="qual-draw__cell-title-content">player</div>
                    </div>
                </div>
            </div>
            {
                props.items.map((item, i) => {
                    return (
                        <div className="qual-draw__row" key={i}>
                            <div className={`${qualDrawCellClass} qual-draw__cell--player`}>
                                <div className="qual-draw__cell-player">
                                    <CountryFlag
                                        childCss={'qual-draw__cell-player-flag'}
                                        image={item.countryFlag}
                                        title={item.countryName}
                                    />
                                    <div className="qual-draw__cell-player-name">
                                        {item.lastName.toUpperCase()}, {item.firstName} {getPlayerStatusSuffix(item.playerStatus)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

QualLeaderboardDefaultView.propTypes = {
    items: PropTypes.array.isRequired
};

export default QualLeaderboardDefaultView;
